import { IRequirementResponse } from "@wingspanhq/payments/dist/interfaces";
import {
  ContextItem,
  RequirementContextType,
  RequirementStatusViewProps
} from "../../../../types";
import { IBackgroundCheckRequestResponse } from "@wingspanhq/background-checks/dist/lib/interfaces";
import { getBackgroundCheckRequirementStatus } from "./getBackgroundCheckRequirementStatus";

export const getBackgroundCheckPayerRequirementStatus = (
  requirement: IRequirementResponse,
  contextItem: ContextItem,
  backgroundChecksRequest: IBackgroundCheckRequestResponse | undefined
): RequirementStatusViewProps => {
  return getBackgroundCheckRequirementStatus(
    requirement,
    contextItem,
    backgroundChecksRequest,
    RequirementContextType.Payee
  );
};
